var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.total
    ? _c("div", { staticClass: "sip-pager" }, [
        _c("p", { staticClass: "sip-pager__meta" }, [
          _vm._v(
            "\n        Showing " +
              _vm._s(_vm.from) +
              "–" +
              _vm._s(_vm.to) +
              " of " +
              _vm._s(_vm.total) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sip-pager__controls" }, [
          _vm.lastPage > 1
            ? _c(
                "nav",
                {
                  staticClass: "sip-pager__nav",
                  attrs: { "aria-label": "Pagination" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "sip-pager__btn",
                      attrs: {
                        type: "button",
                        disabled: _vm.currentPage <= 1,
                        "aria-label": "Previous page",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.go(_vm.currentPage - 1)
                        },
                      },
                    },
                    [_vm._v("‹")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.pageRange, function (page, idx) {
                    return _c(
                      "button",
                      {
                        key: "p-" + idx + "-" + page,
                        staticClass: "sip-pager__btn",
                        class: {
                          "is-active": page === _vm.currentPage,
                          "is-ellipsis": page === "...",
                        },
                        attrs: {
                          type: "button",
                          disabled: page === "...",
                          "aria-current":
                            page === _vm.currentPage ? "page" : null,
                          "aria-label":
                            page === "..." ? "More pages" : "Page " + page,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.go(page)
                          },
                        },
                      },
                      [_vm._v(_vm._s(page))]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "sip-pager__btn",
                      attrs: {
                        type: "button",
                        disabled: _vm.currentPage >= _vm.lastPage,
                        "aria-label": "Next page",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.go(_vm.currentPage + 1)
                        },
                      },
                    },
                    [_vm._v("›")]
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showPageLength
            ? _c("label", { staticClass: "sip-pager__size" }, [
                _c(
                  "select",
                  {
                    staticClass: "sip-pager__select",
                    attrs: {
                      name: "page_length",
                      "aria-label": "Rows per page",
                    },
                    domProps: { value: _vm.pageLength },
                    on: { change: _vm.updateValue },
                  },
                  _vm._l(_vm.getConfig("pagination"), function (option) {
                    return _c(
                      "option",
                      { key: option, domProps: { value: option } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(option) +
                            " / page\n                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }